import React from "react";
import StepTitle from "./StepTitle.js";
import Welcome from "./welcome/welcome-step.js";
import WhatsNew from "./whats-new/step.js";
import BlockchainStep from "./blockchain/blockchain-step.js";
import BlockStep from "./block/block-step.js";
import IndexStep from "./index/index-step.js";
import TimestampStep from "./timestamp/timestamp-step.js";
import HashStep from "./hash/hash-step.js";
import Hash2Step from "./hash-2/hash-step.js";
import Hash3Step from "./hash-3/hash-step.js";
import PreviousHashStep from "./previous-hash/previous-hash-step.js";
import DataStep from "./data/data-step.js";
import MutateStep from "./mutate/mutate-step.js";
import Mutate2Step from "./mutate-2/step.js";
import MiningStep from "./mining/mining-step.js";
import NonceStep from "./nonce/step.js";
import AddStep from "./add-block/step.js";
import ValidBlockStep from "./valid-block/step.js";
import P2pStep from "./p2p/step.js";
import AddPeerStep from "./add-peer/step.js";
import StatusStep from "./status-peer/step.js";
import PeerMessageStep from "./peer-messages/step.js";
import CommunicateStep from "./communicate/step.js";
import CommunicateStep2 from "./communicate-2/step.js";
import CommunicateStep3 from "./communicate-3/step.js";
import CommunicateStep4 from "./communicate-4/step.js";
import ImmutabilityStep from "./immutability/step.js";
import AttackStep from "./51-attack/step.js";
import ThatsItStep from "./thats-it/step.js";

const style = {
  borderRadius: '10px',
  beacon: {
    inner: '#f04134',
    outer: '#880a38'
  },
  arrow: {
    display: 'none'
  },
  skip: {
    color: '#ff6382'
  },
  backgroundColor: '#1a1b1f',
  color: '#fff',
  mainColor: '#4353ff',
}

export default [
  {
    title: <StepTitle />,
    text: <Welcome />,
    selector: '.welcome',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "BLOCKCHAIN DEMO 2.O",
    titleIcon: "rocket"
  },
  {
    title: <StepTitle />,
    text: <WhatsNew />,
    selector: '.whats-new',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "WHAT'S NEW IN 2.0",
    titleIcon: "question-circle-o"
  },
  {
    title: <StepTitle />,
    text: <BlockchainStep />,
    selector: '.blockchain-step',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "BLOCKCHAIN",
    titleIcon: "database"
  },
  {
    title: <StepTitle />,
    text: <BlockStep />,
    selector: '.genesis',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "BLOCK",
    titleIcon: "appstore-o"
  },
  {
    title: <StepTitle />,
    text: <IndexStep />,
    selector: '.genesis-index',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "INDEX",
    titleIcon: "tag-o"
  },
  {
    title: <StepTitle />,
    text: <TimestampStep />,
    selector: '.genesis-timestamp',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "TIMESTAMP",
    titleIcon: "calendar"
  },
  {
    title: <StepTitle />,
    text: <HashStep />,
    selector: '.genesis-hash',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "HASH",
    titleIcon: "barcode"
  },
  {
    title: <StepTitle />,
    text: <Hash2Step />,
    selector: '.genesis-hash-2',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "VALID HASH",
    titleIcon: "check"
  },
  {
    title: <StepTitle />,
    text: <Hash3Step />,
    selector: '.genesis-hash-3',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "BLOCK HASH CALCULATION",
    titleIcon: "calculator"
  },
  {
    title: <StepTitle />,
    text: <PreviousHashStep />,
    selector: '.genesis-previous-hash',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "PREVIOUS HASH",
    titleIcon: "step-backward"
  },
  {
    title: <StepTitle />,
    text: <DataStep />,
    selector: '.genesis-data',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "DATA",
    titleIcon: "file-text"
  },
  {
    title: <StepTitle />,
    text: <NonceStep />,
    selector: '.genesis-nonce',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "NONCE",
    titleIcon: "tool"
  },
  {
    title: <StepTitle />,
    text: <MiningStep />,
    selector: '.genesis-mine',
    position: 'left',
    allowClicksThruHole: true,
    style: style,
    titleText: "MINING A BLOCK",
    titleIcon: "tool"
  },
  {
    title: <StepTitle />,
    text: <MutateStep />,
    selector: '.genesis-mutate',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "DATA MUTATION",
    titleIcon: "edit"
  },
  {
    title: <StepTitle />,
    text: <Mutate2Step />,
    selector: '.genesis-mutate-2',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "MUTATION EFFECT",
    titleIcon: "disconnect"
  },
  {
    title: <StepTitle />,
    text: <AddStep />,
    selector: '.mine',
    position: 'top',
    allowClicksThruHole: true,
    style: style,
    titleText: "ADDING A NEW BLOCK",
    titleIcon: "plus"
  },
  {
    title: <StepTitle />,
    text: <ValidBlockStep />,
    selector: '.is-valid',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "ADDING VALID BLOCKS",
    titleIcon: "check-square-o"
  },
  {
    title: <StepTitle />,
    text: <P2pStep />, 
    selector: '.p2p',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "PEER-TO-PEER NETWORK",
    titleIcon: "team"
  },
  {
    title: <StepTitle />,
    text: <AddPeerStep />, 
    selector: '.ant-tabs-extra-content',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "ADD PEER",
    titleIcon: "usergroup-add"
  },
  {
    title: <StepTitle />,
    text: <StatusStep />, 
    selector: '.ant-tabs-nav',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "PEER STATUS",
    titleIcon: "user"
  },
  {
    title: <StepTitle />,
    text: <PeerMessageStep />, 
    selector: '.ant-tabs-nav-animated',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "PEER MESSAGES",
    titleIcon: "message"
  },
  {
    title: <StepTitle />,
    text: <CommunicateStep />, 
    selector: '.ant-tabs-nav-wrap',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "PEER COMMUNICATION",
    titleIcon: "customer-service"
  },
  {
    title: <StepTitle />,
    text: <CommunicateStep2 />, 
    selector: '.ant-tabs-nav-scroll',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "P2P TOUR PT.1",
    titleIcon: "up-square-o"
  },
  {
    title: <StepTitle />,
    text: <CommunicateStep3 />, 
    selector: '.ant-tabs-nav-container',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "P2P TOUR PT.2",
    titleIcon: "switcher"
  },
  {
    title: <StepTitle />,
    text: <CommunicateStep4 />, 
    selector: '.ant-tabs-bar',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "P2P TOUR PT.3",
    titleIcon: "sync"
  },
  {
    title: <StepTitle />,
    text: <ImmutabilityStep/>, 
    selector: '.immutability',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "IMMUTABILITY",
    titleIcon: "safety"
  },
  {
    title: <StepTitle />,
    text: <AttackStep />, 
    selector: '.fifty-attack',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "51% ATTACK",
    titleIcon: "exception"
  },
  {
    title: <StepTitle />,
    text: <ThatsItStep />, 
    selector: '.final',
    position: 'bottom',
    allowClicksThruHole: true,
    style: style,
    titleText: "FINISH",
    titleIcon: "heart-o"
  },

]

/*
What is bitcoin? 

Bitcoin is a decentrailised digital currency.

This demo will guide you each component of the bitcoin architecture.

Want to keep up to date with more cool stuff? Sign up here!


Let's mine our first block!

Click on the MINE button to mine a block

For now, leave the UNCONFIRMED TRANSACTIONS blank

3 Statuses

- Blue - currently active
- Green - connected
- Red - not connected

What happens when you connect to a peer:

1. Ask peer for latest block



1. Peer - connected

- Connect to its connected peers

- 

2. Peer- not connected

Let's run through this diagram.

Connect to peer => Ask peer for latest block => one block larger => add block

Mine 2 blocks => Add peer => connect to peer => replace chain

*/


// WEBPACK FOOTER //
// ./src/steps/steps.js